var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M28.25 2.867H14V.053c.662-.03 1.332-.047 2-.053 3.75.033 7.567.432 9.69 1.263a8.055 8.055 0 0 1 2.56 1.604Zm2.157 2.96c.57 1.173.76 2.082.76 2.082.063.26.121.522.176.784H14V5.827h16.407Zm1.396 5.826c.104.974.162 1.935.185 2.867H14v-2.867h17.803ZM.013 17.48h31.972c-.026.928-.09 1.889-.2 2.867H.202a34.455 34.455 0 0 1-.19-2.867Zm.663 5.827h30.64c-.057.272-.118.545-.183.817 0 0-.186.892-.744 2.05H1.61c-.557-1.158-.744-2.05-.744-2.05a25.997 25.997 0 0 1-.19-.817Zm3.071 5.826h24.505a8.06 8.06 0 0 1-2.595 1.637C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23a8.06 8.06 0 0 1-2.595-1.637Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M14 .053V14.52H.015c.06-2.108.314-4.387.851-6.645 0 0 1.03-4.918 5.476-6.646C8.061.574 10.945.188 14 .053Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7 9.667-2.94 2.045 1.037-3.427-2.853-2.163 3.58-.073L7 2.667l1.175 3.382 3.58.073-2.853 2.163 1.037 3.427-2.94-2.045Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagLbr = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagLbr_default = SvgFlagLbr;
export {
  FlagLbr_default as default
};
